import ScArticle from '@garmin/support-components/src/components/ScArticle/index.vue';
import ScEfmSurvey from '@garmin/support-components/src/components/ScEfmSurvey/index.vue';

import { v4 as uuidv4 } from 'uuid';
import { mapState } from 'pinia';
import { useGlobalStore } from '../../stores/global/index.js';
import { useProductStore } from '../../stores/product/index.js';
import TranslationsMixin from '../../mixins/translations';
import { parseEmbeddedContent } from '../../util/content';

export default {
  name: 'ContentFaqRenderable',
  mixins: [TranslationsMixin],
  components: {
    ScArticle,
    ScEfmSurvey,
  },
  props: {
    faqDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uuidv4,
      surveyTagName: null,
      contentType: 'content_faq',
      surveyNoProduct: 'No Product',
      isExpanded: false,
    };
  },
  mounted() {
    const setExpandCollapseButtonLabel = setInterval(() => {
      const expandCollapseAllButton = document.querySelector('.sc__article__content__button');
      if (expandCollapseAllButton) {
        const allGtDisplayClasses = document.querySelectorAll('.GTDisplay');
        let hasToggleVisibility = false;
        allGtDisplayClasses.forEach((gtDisplayClass) => {
          if (gtDisplayClass.classList.contains('toggle-visibility')) {
            hasToggleVisibility = true;
          }
        });
        if (hasToggleVisibility) {
          expandCollapseAllButton.innerHTML = this.expandLabelText;
          this.isExpanded = false;
        } else {
          expandCollapseAllButton.innerHTML = this.collapseLabelText;
          this.isExpanded = true;
        }
        clearInterval(setExpandCollapseButtonLabel);
      }
    }, 100);
  },
  computed: {
    ...mapState(useGlobalStore, ['locale', 'systemConfig', 'getLocale']),
    ...mapState(useProductStore, ['productDetails']),
    getSurveyTagName() {
      return this.$route.query.issueTagName || '';
    },
    getSurveyProductName() {
      return this.productDetails?.displayName || this.surveyNoProduct;
    },
    getSurveyProductId() {
      return this.productDetails?.productId || this.surveyNoProduct;
    },
    shouldRenderSurvey() {
      return (
        this.translations.commonSettings.generalSettings.faqSurveyEnabled
        && this.faqDetails
      );
    },
    getRelatedContent() {
      return (this.faqDetails.relatedContent || {}).content || [];
    },
    compiledFaqContent() {
      return (this.faqDetails ? parseEmbeddedContent(this.faqDetails) : '');
    },
    collapseLabelText() {
      return `- ${this.translations.commonSettings.navigation.collapseLabelText}`;
    },
    expandLabelText() {
      return `+ ${this.translations.commonSettings.navigation.expandLabelText}`;
    },
  },
  methods: {
    generateFaqLink(id) {
      const { params: { locale, path } } = this.$route;
      return `/${locale}/${path}/faq/${id}`;
    },
    expandAll() {
      const displayElements = document.querySelectorAll('.GTDisplay.toggle-visibility');
      const displayElementsArray = Array.from(displayElements);
      displayElementsArray.forEach((element) => element.classList.remove('toggle-visibility'));

      const displayArrows = document.querySelectorAll('.arrow');
      const displayArrowsArray = Array.from(displayArrows);
      displayArrowsArray.forEach((element) => element.classList.add('rotate-me'));

      const detailsElements = document.querySelectorAll('details');
      const detailsElementsArray = Array.from(detailsElements);
      detailsElementsArray.forEach((element) => element.setAttribute('open', ''));
    },
    collapseAll() {
      const displayElements = document.querySelectorAll('.GTDisplay');
      const displayElementsArray = Array.from(displayElements);
      displayElementsArray.forEach((element) => element.classList.add('toggle-visibility'));

      const displayArrows = document.querySelectorAll('.arrow');
      const displayArrowsArray = Array.from(displayArrows);
      displayArrowsArray.forEach((element) => element.classList.remove('rotate-me'));

      const detailsElements = document.querySelectorAll('details');
      const detailsElementsArray = Array.from(detailsElements);
      detailsElementsArray.forEach((element) => element.removeAttribute('open'));
    },
    expandCollapseAll(event) {
      if (this.isExpanded) {
        this.collapseAll();
        event.target.innerHTML = this.expandLabelText; //eslint-disable-line
      } else {
        this.expandAll();
        event.target.innerHTML = this.collapseLabelText; //eslint-disable-line
      }
      this.isExpanded = !this.isExpanded;
    },
    expandCollapseElement() {
      const displayElements = document.querySelectorAll('.GTDisplay.toggle-visibility');
      const displayElementsArray = Array.from(displayElements);

      const detailsElements = document.querySelectorAll('details:not([open])');
      const detailsElementsArray = Array.from(detailsElements);

      if (displayElementsArray.length === 0
        && detailsElementsArray.length === 0) {
        this.isExpanded = true;
        const expandCollapseButton = document.querySelector('.sc__article__content__button');
        expandCollapseButton.innerHTML = this.collapseLabelText;
      }

      if (displayElementsArray.length === document.querySelectorAll('.GTDisplay').length
        && detailsElementsArray.length === document.querySelectorAll('details').length) {
        this.isExpanded = false;
        const expandCollapseButton = document.querySelector('.sc__article__content__button');
        expandCollapseButton.innerHTML = this.expandLabelText;
      }
    },
  },
};
